import { Hash, Plus, Trash2 } from "lucide-react";
import { inputCls, labelCls } from "./constants";

export default function CodesSection({ codes, setCodes, updateCode, addCode, pages, setPages }) {
  const ei = pages?.extra_internet || {};
  const updEi = (field, value) => setPages({ ...pages, extra_internet: { ...ei, [field]: value } });
  return (
    <section>
      <h3 className="flex items-center gap-2 font-bold text-slate-800 text-lg mb-4">
        <Hash size={18} className="text-[#1f3a8a]" /> Sekcja „Doładuj kodem" (nad tabelą kodów)
      </h3>
      <div className="rounded-xl border border-slate-200 p-4 bg-slate-50/50 space-y-3 mb-6">
        <div className="grid md:grid-cols-2 gap-3">
          <div>
            <label className={labelCls}>Nadtytuł (eyebrow)</label>
            <input data-testid="ei-eyebrow" className={inputCls} value={ei.eyebrow || ""} onChange={(e) => updEi("eyebrow", e.target.value)} />
          </div>
          <div>
            <label className={labelCls}>Tytuł</label>
            <input data-testid="ei-title" className={inputCls} value={ei.title || ""} onChange={(e) => updEi("title", e.target.value)} />
          </div>
        </div>
        <div>
          <label className={labelCls}>Podtytuł</label>
          <input data-testid="ei-subtitle" className={inputCls} value={ei.subtitle || ""} onChange={(e) => updEi("subtitle", e.target.value)} />
        </div>
        <div className="grid grid-cols-3 gap-3">
          <div>
            <label className={labelCls}>Kolumna „Kod"</label>
            <input className={inputCls} value={ei.col_code || ""} onChange={(e) => updEi("col_code", e.target.value)} />
          </div>
          <div>
            <label className={labelCls}>Kolumna „Wielkość"</label>
            <input className={inputCls} value={ei.col_size || ""} onChange={(e) => updEi("col_size", e.target.value)} />
          </div>
          <div>
            <label className={labelCls}>Kolumna „Cena"</label>
            <input className={inputCls} value={ei.col_price || ""} onChange={(e) => updEi("col_price", e.target.value)} />
          </div>
        </div>
        <div>
          <label className={labelCls}>Notka pod tabelą</label>
          <textarea className={inputCls} rows={2} value={ei.note_bottom || ""} onChange={(e) => updEi("note_bottom", e.target.value)} />
        </div>
      </div>

      <div className="flex items-center justify-between mb-4">
        <h3 className="flex items-center gap-2 font-bold text-slate-800 text-lg">
          <Hash size={18} className="text-[#1f3a8a]" /> Kody paczek internetu (USSD)
        </h3>
        <button data-testid="add-code" onClick={addCode} className="inline-flex items-center gap-1 text-sm font-semibold text-[#1f3a8a] hover:text-[#15296b]">
          <Plus size={16} /> Dodaj kod
        </button>
      </div>
      <div className="space-y-3">
        {codes.map((c, i) => (
          <div key={i} data-testid={`code-${i}`} className="grid grid-cols-[1fr_1fr_100px_40px] gap-3 items-end rounded-xl border border-slate-200 p-3 bg-slate-50/50">
            <div>
              <label className={labelCls}>Kod</label>
              <input data-testid={`code-value-${i}`} className={`${inputCls} font-mono`} value={c.code} onChange={(e) => updateCode(i, "code", e.target.value)} />
            </div>
            <div>
              <label className={labelCls}>Wielkość</label>
              <input data-testid={`code-size-${i}`} className={inputCls} value={c.size} onChange={(e) => updateCode(i, "size", e.target.value)} />
            </div>
            <div>
              <label className={labelCls}>Cena (zł)</label>
              <input data-testid={`code-price-${i}`} type="number" className={inputCls} value={c.price} onChange={(e) => updateCode(i, "price", e.target.value)} />
            </div>
            <button onClick={() => setCodes((prev) => prev.filter((_, idx) => idx !== i))} className="text-red-500 hover:text-red-700 pb-2"><Trash2 size={16} /></button>
          </div>
        ))}
      </div>
    </section>
  );
}
